import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-[#1e3a52] text-[#dcd6c4] mt-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="flex flex-col items-start">
          <div className="opacity-95">
            <Logo size={140} />
          </div>
          <p className="mt-6 text-sm leading-relaxed text-[#dcd6c4]/80 max-w-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
            A premium producer of ultra-high phenolic extra virgin olive oil. Engineered for wellness, longevity, and measurable clinical impact.
          </p>
        </div>

        <div>
          <h4 className="text-[#f4f0e6] uppercase tracking-widest text-xs mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>Shop</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/shop" className="hover:text-white">High Polyphenol Olive Oil</Link></li>
            <li><Link to="/analysis" className="hover:text-white">2025 Lab Analysis</Link></li>
            <li><Link to="/waitlist" className="hover:text-white">Availability & Waitlist</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[#f4f0e6] uppercase tracking-widest text-xs mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>Learn</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/health-benefits" className="hover:text-white">Health Benefits</Link></li>
            <li><Link to="/the-edge" className="hover:text-white">The Edge</Link></li>
            <li><Link to="/about" className="hover:text-white">Our Story</Link></li>
            <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
            <li><Link to="/press" className="hover:text-white">Press & Media</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[#f4ede0] uppercase tracking-widest text-xs mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>Stay in touch</h4>
          <div className="flex gap-3 mb-5">
            <a href="#" aria-label="Instagram" className="w-9 h-9 grid place-items-center border border-[#dcd6c4]/40 rounded-full hover:bg-[#4a7ba1] hover:border-[#4a7ba1] transition-colors"><Instagram size={16} /></a>
            <a href="#" aria-label="Facebook" className="w-9 h-9 grid place-items-center border border-[#dcd6c4]/40 rounded-full hover:bg-[#4a7ba1] hover:border-[#4a7ba1] transition-colors"><Facebook size={16} /></a>
            <a href="#" aria-label="Youtube" className="w-9 h-9 grid place-items-center border border-[#dcd6c4]/40 rounded-full hover:bg-[#4a7ba1] hover:border-[#4a7ba1] transition-colors"><Youtube size={16} /></a>
            <Link to="/press" aria-label="Contact" className="w-9 h-9 grid place-items-center border border-[#dcd6c4]/40 rounded-full hover:bg-[#4a7ba1] hover:border-[#4a7ba1] transition-colors"><Mail size={16} /></Link>
          </div>
          <Link to="/press" className="text-sm text-[#dcd6c4]/80 hover:text-white underline">Send us a message &rarr;</Link>
        </div>
      </div>
      <div className="border-t border-[#dcd6c4]/15">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-[#dcd6c4]/60">
          <p>© {new Date().getFullYear()} Fountain of Youth EVOO. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <Link to="/press" className="hover:text-white">Press</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
